/**
 * JS Extend string functions for my needs
 */
String.prototype.phoneFormat = function() {
  return this.replace(/\s/g, "");
};
String.prototype.excerpt = function(length, end = "...") {
  return this.length > length ? this.substring(0, length) + end : this;
};
String.prototype.capitalize = function() {
  const string = this;
  return string.charAt(0).toUpperCase() + string.slice(1);
};

String.prototype.stripHtml = function() {
  const html = this;
  var doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent || "";
};

String.prototype.decodeHtmlEntities = function() {
  const text = this;
  var textarea = document.createElement("textarea");
  textarea.innerHTML = text;
  return textarea.value;
};

/**
 * Element.closest() polyfill
 * https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
 */
if (!Element.prototype.closest) {
  if (!Element.prototype.matches) {
    Element.prototype.matches =
      Element.prototype.msMatchesSelector ||
      Element.prototype.webkitMatchesSelector;
  }
  Element.prototype.closest = function(s) {
    var el = this;
    var ancestor = this;
    if (!document.documentElement.contains(el)) return null;
    do {
      if (ancestor.matches(s)) return ancestor;
      ancestor = ancestor.parentElement;
    } while (ancestor !== null);
    return null;
  };
}

/* Document on load trick */
HTMLDocument.prototype.ready = new Promise(function(resolve) {
  if (document.readyState != "loading") resolve();
  else
    document.addEventListener("DOMContentLoaded", function() {
      resolve();
    });
});

Element.prototype.remove = function() {
  this.parentElement.removeChild(this);
};
NodeList.prototype.remove = HTMLCollection.prototype.remove = function() {
  for (var i = this.length - 1; i >= 0; i--) {
    if (this[i] && this[i].parentElement) {
      this[i].parentElement.removeChild(this[i]);
    }
  }
};
/* $.fn.isInViewport = function (offset) {
    var elementTop = $(this).offset().top - offset;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
}; */

if (typeof Object.assign != "function") {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target, varArgs) {
      // .length of function is 2
      "use strict";
      if (target == null) {
        // TypeError if undefined or null
        throw new TypeError("Cannot convert undefined or null to object");
      }

      var to = Object(target);

      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        if (nextSource != null) {
          // Skip over if undefined or null
          for (var nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}
